export const yeuCauXuatHoaDon = {
  titles: {
    list: 'Invoice requests',
    detail: 'Invoice request detail',
    create: 'Create invoice request',
  },
  sections: {
    list: { title: 'Invoice request' },
    commentThread: 'Comments',
    pdfViewer: 'Draft invoice',
    auditLog: 'Change history',
    buyerInfo: 'Buyer information',
    transitionBar: 'Actions',
    chiTietHangHoa: 'Goods details',
    thuKhac: 'Other charges',
    tongKetTien: 'Total summary',
    hoaDonChinhThuc: 'Official invoice',
  },
  form: {
    sectionHeader: 'General information',
    sectionLines: 'Invoice line list',
    nguonTitle: 'Invoice item details',
    nguonTabTong: 'Total',
    productSearch: 'Search item code / name',
    tongSoMatHang: 'Items',
    tongSoLuong: 'Total qty',
    tongTienHang: 'Subtotal',
    lineCount: '{count} line(s)',
    emptyAddProduct: 'Search and pick a product above to add a line.',
    emptyAddProductPos: 'Type an item code / name in the green bar (F3) to add a line.',
    motKhachNhieuHoaDon:
      'One request can include several invoices (one company each) but only one customer. One order with many item codes can still be split across companies.',
    hoaDonThuTu: 'Invoice {index}',
  },
  fields: {
    maYeuCau: 'Request code',
    qr: 'QR',
    hoaDonGoc: 'Original invoice',
    maHoaDonGoc: 'Original invoice code',
    hoaDonNguon: 'Source invoices',
    khachHang: 'Customer',
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    nhanVienPhuTrach: 'Sales rep',
    tenCongTyLayThue: 'Tax company name',
    diaChiLayThue: 'Tax company address',
    soDienThoai: 'Phone',
    email: 'Email',
    ghiChu: 'Note',
    congTyXuatHd: 'Invoicing company',
    soLuongTuDo: 'Quantity is free to edit, not limited by the original invoices',
    tenNguoiMua: 'Buyer name',
    maSoThue: 'Tax code',
    soMatHang: 'Items',
    soTien: 'Amount',
    diaChiHoaDon: 'Invoice address',
    tinhThanhHoaDon: 'Province/city',
    phuongXaHoaDon: 'Ward/commune',
    soCCCD: 'ID card no.',
    soHoChieu: 'Passport no.',
    emailHoaDon: 'Invoice email',
    soDienThoaiHoaDon: 'Invoice phone',
    nganHang: 'Bank',
    soTaiKhoanNganHang: 'Bank account no.',
    lyDoXuat: 'Reason for issuance',
    trangThai: 'Status',
    soLanReject: 'Reject count',
    rejectCount: 'Rejected {count} time(s)',
    createdAt: 'Created at',
    createdBy: 'Created by',
    updatedAt: 'Updated at',
    updatedBy: 'Updated by',
    version: 'Version',
    uploadedBy: 'Uploaded by',
    uploadedAt: 'Uploaded at',
    loaiFile: 'File type',
    actions: 'Actions',
    anonymousAuthor: '(Anonymous)',
    requiredMark: ' (required)',
    optionalMark: ' (optional)',
    hintTextBuyerInfo:
      '3 required fields: tax code, tax company name, tax company address.',
    maHangHoa: 'Item code',
    tenHangHoa: 'Item name',
    donViTinh: 'UOM',
    donViTinhBan: 'Sale UOM',
    donViTinhCoBan: 'Base unit',
    soLuong: 'Qty',
    soLuongBan: 'Sale qty',
    soLuongCoBan: 'Base qty',
    donGia: 'Unit price',
    donGiaBan: 'Sale unit price',
    giamGiaBan: 'Sale discount',
    giaBan: 'Sale price',
    giaBanCoBan: 'Base price',
    thanhTien: 'Line total',
    thanhTienBan: 'Sale amount',
    thanhTienCoBan: 'Base amount',
    ngayKhaiVat: 'VAT declared date',
    tenKhaiVat: 'VAT declared name',
    donViTinhKhaiVat: 'VAT unit',
    tyLeBanCoBan: 'Conversion rate',
    tyLeBanCoBanHint: '1 sale unit = Rate × base unit',
    tyLeBanTrenDvt: 'Sale UOM / UOM',
    tyLeBanTrenDvtHint: '1 sale unit = Rate × UOM',
    tyLeQuyDoi: 'VAT unit / sale unit',
    tyLeQuyDoiHint: '1 VAT unit = Rate × sale unit',
    soLuongXuatVat: 'VAT issue qty',
    soLuongXuatVatHint: 'Enter in VAT unit. Default = sale qty ÷ (VAT unit / sale unit)',
    donGiaXuatVat: 'VAT issue unit price',
    donGiaXuatVatHint:
      'Enter in VAT unit. Default = sale unit price × (VAT unit / sale unit)',
    donGiaKhaiVat: 'VAT declared unit price (VND)',
    soLuongTonKhaiVat: 'VAT qty left',
    phanTramVat: '% VAT',
    tenThuKhac: 'Charge name',
    giaTri: 'Amount',
    phanTram: 'Percent',
    tongTienHang: 'Subtotal',
    giamGia: 'Discount',
    tongSauGiamGia: 'After discount',
    thuKhac: 'Other charges',
    thueGtgt: 'VAT',
    khachCanTra: 'Customer owes',
    khachDaTra: 'Customer paid',
    tienThua: 'Change',
    soHoaDon: 'Invoice no.',
    kyHieuHoaDon: 'Serial',
    ngayXuatHoaDon: 'Issue date',
    soHoaDonDaXuat: 'Issued {soHoaDon} · {ngay}',
  },
  filters: {
    maYeuCau: 'Request code',
    maHoaDon: 'Invoice code',
    soHoaDon: 'Invoice number',
    maSoThue: 'Tax code',
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer / buyer name',
    hintSection: 'Invoice request filters',
    hintBody: 'Filter by status, date, request code',
    statusSection: 'Status',
    dateRangeSection: 'Created date',
    hoaDonGocSection: 'Original invoice',
    rejectSection: 'Rejection filter',
    allStatus: 'All statuses',
    daBiReject: 'Only requests rejected by customer',
    dateRangePlaceholder: 'Select date range',
    presetHomNay: 'Today',
    presetTuanNay: 'This week',
    presetThangNay: 'This month',
    presetTuyChinh: 'Custom',
    resetFilter: 'Reset filters',
  },
  placeholders: {
    searchMaYeuCau: 'Search by request code...',
    searchQueue: 'Search',
    searchKhachHang: 'Search customer code / name...',
    inputLyDoXuat: 'Enter reason for issuance (e.g. Invoice for company A)',
    chonCongTy: 'Pick from customer data',
    chonTaiKhoan: 'Select bank account',
    addHangHoa: 'Add a product to the request...',
    writeComment: 'Write a comment...',
    inputLyDoReject: 'Enter reason customer declined (optional)',
    inputLyDoHuy: 'Enter cancellation reason (optional)',
    hoaDonGocId: 'Original invoice UUID',
    tuNgay: 'From date',
    denNgay: 'To date',
    kyHieuHoaDon: 'e.g. 1C26TAA',
    chonKhaiVat: '— Select VAT declaration —',
    chonHangHoa: 'Click to pick a product',
    doiHangHoaHint: 'Click (or Enter) to pick another product',
    chuaCoKhaiVat: 'No VAT info yet',
    khongTimThayHang: 'No products found',
    khongTimThayKhaiVat: 'No VAT declaration found',
  },
  messages: {
    createAndGuiKtSuccess: 'Created request {maYeuCau} and sent it to the accountant.',
    createButGuiKtFailed: 'Created request {maYeuCau} but could not send it to the accountant: {reason}',
    listSummary: 'Total {count} requests',
    createSuccess: 'Invoice request {maYeuCau} created.',
    yeuCauIntro:
      'Review goods, unit prices and buyer info. On submit, the request is created in "New" status.',
    transitionSuccess: 'Request status updated.',
    transitionFailed: 'Could not update status. Please refresh and try again.',
    commentSuccess: 'Comment sent.',
    commentEmpty: 'Please enter a comment.',
    commentFailed: 'Could not send comment. Please try again.',
    uploadPdfSuccess: 'Draft invoice version v{n} uploaded.',
    uploadPdfFailed: 'Could not upload draft file. Please try again.',
    loadDetailFailed: 'Could not load request detail. Please try again later.',
    loadingDetail: 'Loading request detail...',
    saving: 'Saving...',
    noPermission: 'You do not have permission to perform this action.',
    noTransition: 'No actions available in this state.',
    fileTooLarge: 'File exceeds 10MB limit.',
    fileInvalidType: 'Invalid file type. Only PDF, JPEG, PNG, Excel (xlsx/xls/csv) accepted.',
    chooseFile: 'Choose a file or drag and drop here (PDF/JPEG/PNG, max 10MB)',
    validateBuyerInfoRequired:
      'Please fill all 3 required fields: tax code, tax company name, tax company address.',
    validateLyDoXuatRequired: 'Please enter a reason for issuance.',
    needLines: 'Please add at least one invoice line.',
    needKhachHang: 'Please select a customer.',
    khacKhachHang: 'Selected invoices do not share one customer. One invoice request can only cover a single customer.',
    needCompany: 'Each item needs an invoicing company.',
    validateLyDoHuyRequired: 'Please enter a cancellation reason.',
    updateBuyerSuccess: 'Buyer information updated.',
    updateBuyerFailed: 'Could not update buyer information.',
    updateSuccess: 'Invoice request {maYeuCau} updated.',
    updateFailed: 'Could not update the invoice request.',
    doiTrangThaiSuccess: 'Status changed to "{trangThai}".',
    xoaFileSuccess: 'File deleted.',
    confirmXoaFile: 'Delete this invoice file?',
    coThayDoiChuaLuu: 'Unsaved changes',
    soSp: '{n} items',
    chuaCoFile: 'No files yet',
    fileDropHint: 'Drag & drop, Ctrl+V or click Choose file · PDF, image, Excel ≤10MB',
    clipboardKhongCoAnh: 'No image in clipboard. Copy an image, then click Paste image.',
    uploadNhapSuccess: 'Uploaded {n} draft invoice file(s).',
    dangTaiLen: 'Uploading...',
    emptyList: {
      heading: 'No invoice requests yet',
      body: 'When sales staff create an invoice request, it will appear here.',
    },
    emptyListFiltered: {
      heading: 'No matching requests found',
      body: 'Try removing some filters or reset to see all requests.',
    },
    emptyComments: 'No comments yet. Leave the first comment.',
    emptyFiles: 'No draft invoice files uploaded yet.',
    emptyAuditLog: 'No change history yet.',
    emptyChiTietHangHoa: 'No goods details.',
    emptyThuKhac: 'No other charges.',
    rowCount: '{count} row(s)',
    xuatHoaDonSuccess: 'Invoice issued for request {maYeuCau}.',
    uploadChinhThucSuccess: 'Official invoice file attached.',
    emptyFilesChinhThuc: 'No official invoice file attached.',
    vuotTonKhaiVat: 'Quantity exceeds the VAT declared quantity left',
  },
  actions: {
    taoVaGuiKeToan: 'Create & send to accountant',
    create: 'Create invoice request',
    send: 'Submit request',
    uploadDraft: 'Upload draft invoice',
    guiKeToan: 'Send to accounting',
    guiKhach: 'Send to customer',
    khachDongY: 'Customer approved',
    khachKhongDongY: 'Customer declined',
    hoanThanh: 'Complete',
    huyYeuCau: 'Cancel request',
    editBuyerInfo: 'Edit buyer info',
    saveBuyerInfo: 'Save',
    cancelEdit: 'Cancel edit',
    viewDetail: 'View detail',
    writeComment: 'Write comment',
    sendComment: 'Send comment',
    back: 'Back',
    refresh: 'Refresh',
    addLine: 'Add empty line',
    xuatHoaDon: 'Issue invoice',
    xacNhanXuatHoaDon: 'Confirm issue',
    dinhKemHoaDonChinhThuc: 'Attach official invoice',
    xoaFile: 'Delete file',
    hoanTac: 'Undo',
    chonFileHd: 'Choose file',
    danAnh: 'Paste image',
    xuatExcelDaChon: 'Export selected to Excel',
    capNhatDaXuatHd: 'Mark selected as invoiced',
  },
  bulk: {
    exportNeedSelect: 'Select at least one request to export.',
    exportSuccess: 'Exported Excel for {count} request(s).',
    exportSheetNguon: 'Source invoice lines',
    exportSheetXuatVat: 'VAT export lines',
    completeNeedSelect: 'Select at least one request in «Customer approved» status.',
    completeConfirmTitle: 'Mark as invoiced?',
    completeConfirmBody:
      'Move {count} selected request(s) to «Invoiced». Existing invoice no./series are kept; you can fill them later.',
    completeConfirm: 'Update',
    completeSuccess: 'Updated {ok}/{total} request(s).',
    completePartial: 'Partial update: {ok} ok, {fail} failed.',
    completeSkip: 'Skipped {count} request(s) not in «Customer approved».',
  },
  aria: {
    back: 'Back to list',
    refresh: 'Refresh detail',
    uploadFile: 'Upload draft invoice file',
    sendComment: 'Send comment',
    viewDetailRow: 'View request detail',
    columnPicker: 'Choose visible columns',
    rejectBadge: 'Customer rejection count',
    selectAllPage: 'Select all rows on this page',
    selectRow: 'Select row',
  },
  detailTabs: {
    chiTiet: 'Information',
    traoDoi: 'Discussion',
    lichSu: 'Edit history',
  },
  expand: {
    rowClickExpand: 'Click to expand details',
  },
  confirm: {
    huyYeuCau: {
      title: 'Cancel invoice request?',
      message:
        'This action cannot be undone. The request will be marked as cancelled but all information (buyer-info, comments, draft files, history) is retained for traceability.',
      confirm: 'Cancel request',
    },
  },
  trangThai: {
    MOI_TAO: 'New',
    CHO_KT_XU_LY: 'Pending accounting',
    CHO_KHACH_DUYET: 'Pending customer',
    KHACH_DONG_Y: 'Customer approved',
    HOAN_THANH: 'Invoice issued',
    DA_HUY: 'Cancelled',
  },
  auditActions: {
    CREATE_YCX: 'Create request',
    GUI_KT: 'Send to accounting',
    GUI_KHACH: 'Send to customer',
    KHACH_DONG_Y: 'Customer approved',
    KHACH_KHONG_DONG_Y: 'Customer rejected',
    HOAN_THANH: 'Issue invoice',
    HUY: 'Cancel request',
    UPLOAD_PDF: 'Upload invoice file',
    CAP_NHAT_YCX: 'Update',
    DOI_TRANG_THAI: 'Change status',
  },
  audit: {
    xoaFile: 'Delete file',
    trong: '(empty)',
  },
  xuatHoaDon: {
    intro:
      'Enter the invoice number issued in the e-invoice software for each invoice (optional, can be added later). After confirming, the request becomes "Invoice issued" — it can still be edited.',
  },
}
